export default "__VITE_ASSET__DFfwv8KT__"